function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { LordIconSizes } from '@/types/client';
import { Button, Text } from '@mantine/core';
import styles from './NavItem.module.scss';
import { Link } from 'react-router';
function NavItem(_param) {
    var name = _param.name, isExternal = _param.isExternal, _param_active = _param.active, active = _param_active === void 0 ? false : _param_active, icon = _param.icon, href = _param.href, onClick = _param.onClick, _param_trigger = _param.trigger, trigger = _param_trigger === void 0 ? 'click' : _param_trigger, props = _object_without_properties(_param, [
        "name",
        "isExternal",
        "active",
        "icon",
        "href",
        "onClick",
        "trigger"
    ]);
    var ref = React.useRef(null);
    var Icon = React.useMemo(function() {
        return icon;
    }, [
        icon
    ]);
    return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
        ref: ref,
        size: "sm",
        role: "group",
        component: Link,
        variant: active ? 'active' : 'transparent',
        to: href,
        classNames: {
            inner: styles.navItemInner,
            root: styles.navItem
        },
        target: isExternal === true ? '_blank' : undefined,
        rel: isExternal === true ? 'external nofollow noopener' : undefined,
        leftSection: /*#__PURE__*/ _jsx(Icon, {
            trigger: "click",
            groupRef: ref,
            size: LordIconSizes.SMALL
        })
    }, props), {
        children: /*#__PURE__*/ _jsx(Text, {
            size: "sm",
            children: name
        })
    }));
}
export default NavItem;
